// F63 / C32 — ONE predicate for "this user's org has Mira (the reflective surface) and may call it".
//
// Both Mira call sites gate GET /api/reflective/opening on this, so neither fires (and 404s) in a
// non-Mira org: the floating MiraLauncher and the docked rail on the teacher workspace. It lived
// inline in MiraLauncher after F63; the teacher workspace shipped the SAME opening query WITHOUT the
// gate, so it 404'd every Teacher Home load in a non-Mira org (C-200 §5). This is the one source.
//
// - role: the canonical fallback used across the app (tenant_role || role); a user object with only
//   `role` must still resolve (App.js, MasterAdminUserDetailPage.js).
// - super_admin (the master-admin console) never mounts Mira by doctrine (MA-2 rider).
// - reflective_available must be === true: absent (the post-login window) means "do not call", never
//   inferred from a 404.
export function reflectiveAvailable(user) {
  const role = user?.tenant_role || user?.role;
  if (!role) return false;
  if (role === "super_admin") return false;
  return user?.reflective_available === true;
}

export default reflectiveAvailable;
